import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { BaseUrl } from '../../BaseUrl/BaseUrl';
import { PrasadOrderDetail } from '../../ApiServices/Prasad/PrasadApi';
import { LoaderContext } from '../../AuthContext/AuthContext';
import LazySection from '../../Pages/Home/LazySection';
import DeliveryTracker from '../DeliveryTracker/DeliveryTracker';
import { GetOrderTrackingDetails } from '../../ApiServices/BookingTrack/BookingTrackApi';

const PrasadOrderDetails = () => {
    const userID = JSON.parse(localStorage.getItem("userID"));
    const [localData, setLocalData] = useState(null);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalRateAmount, setRateTotal] = useState(0);
    const [totalDiscountAmount, setDiscountTotal] = useState(0);
    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null)
    const { setLoader, loader, activeCategory, setActiveCategory, isCartUpdate, setIsCartUpdate } = useContext(LoaderContext)

    const stepMap = [
        { key: "BookingDate", label: "Processed" },
        { key: "ConfirmedDate", label: "Confirmed" },
        { key: "CompletedDate", label: "Completed" },
        { key: "CancelledDate", label: "Cancelled" },
        { key: "RejectedDate", label: "Rejected" }
    ];
    useEffect(() => {
        if (location?.state?.PrasadOrderID !== null && location?.state?.PrasadOrderID !== undefined && location?.state?.PrasadOrderID !== '') {
            GetPrasadOrderDetailsData()
            GetOrderTrackingDetailsData()
        }

    }, []);
    const GetPrasadOrderDetailsData = async () => {
        setLoader(true);
        try {
            const response = await PrasadOrderDetail({
                "START": 0,
                "END": 100,
                "WORD": "none"
            }, location?.state?.PrasadOrderID);

            if (response?.ResponseCode == '0') {
                const responseData = response?.DATA || []
                setLoader(false)

                setOrders(responseData);


            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    }
    useEffect(() => {
        if (!orders?.length) return;

        const totals = orders.reduce(
            (acc, order) => {
                const rate = order.RATE || 0;
                const qty = order.QTY || 0;
                const discountPercent = order.DISCOUNT || 0;
                const discountAmount = Math.round((rate * discountPercent * qty) / 100);

                acc.totalAmount += rate * qty - discountAmount;
                acc.totalRate += rate;
                acc.totalDiscount += order.DiscountAmount || 0;

                return acc;
            },
            { totalAmount: 0, totalRate: 0, totalDiscount: 0 }
        );

        setTotalAmount(totals.totalAmount);
        setRateTotal(totals.totalRate);
        setDiscountTotal(totals.totalDiscount);
    }, [orders]);

    const handleDownloadInvoice = () => {
        const pdfUrl = location?.state?.InvoicePDFURL;
        if (pdfUrl) {
            window.open(pdfUrl, "_blank");
        } else {
            console.error("PDF URL is not available");
        }
    };
    const GetOrderTrackingDetailsData = async () => {
        setLoader(true);
        try {
            let response = await GetOrderTrackingDetails(userID, location?.state?.PrasadOrderID, 'Prasad'); // Replace with actual import/function call
            if (response?.ResponseCode == "0") {
                setLoader(false);

                const list = response?.DATA || [];
                setOrderTrackingDetails(list[0])

            } else {
                console.error("Bad request");
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    }
    return (
        <>
            <div className="m-5 p-5 my-4">
                <div className="row">
                    {/* Left Section: Multiple Order Items */}
                    <div className="col-md-8">
                        {orders?.map((order, index) => (
                            <div key={index} className="card p-3 mb-3 shadow-sm">
                                <div className="d-flex align-items-center">
                                    {/* Product Image on the Left */}
                                    <img
                                        src={order?.PrasadPhotoURL}
                                        alt="Product"
                                        className="rounded"
                                        style={{
                                            width: "180px",
                                            height: "150px",
                                            objectFit: "contain",
                                        }}
                                    />

                                    {/* Product Details in the Center */}
                                    <div className="flex-grow-1 px-3">
                                        <h6 className="fw-bold">{order?.PrasadName}</h6>
                                        <p className="text-muted mb-1">Seller: Myomnamo Spiritual Services Pvt Ltd.</p>
                                    </div>

                                    {/* Price on the Right */}
                                    <div className="text-end">
                                        <h5 className="fw-bold  mb-0">
                                            ₹
                                            {order.RATE * order.QTY -
                                                Math.round(
                                                    (order.RATE * (order.DISCOUNT * order.QTY)) / 100
                                                )}
                                        </h5>
                                        {order.DISCOUNT > 0 && (
                                            <span className="text-muted small text-decoration-line-through">
                                                ₹{order.RATE * order.QTY}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* Order Status */}
                                {/* <hr /> */}
                            </div>
                        ))}
                        {/* <div className="d-flex align-items-center">
                            <span className="text-success fw-bold me-2">✔</span>
                            <p className="mb-0">Order Confirmed, {location.state.ORDER_DATE}</p>
                        </div>

                        
                        <p className="text-muted mt-2">
                            Your order was cancelled as the courier could not deliver it even
                            after multiple attempts.
                        </p> */}
                        {(OrderTrackingDetails !== null && OrderTrackingDetails !== undefined && OrderTrackingDetails !== '') && (

                            <div >
                                <LazySection><DeliveryTracker statusData={OrderTrackingDetails} stepMap={stepMap} moduleName={'EStore'} /></LazySection>
                            </div>
                        )}
                    </div>

                    {/* Right Section: Single Product's Shipping & Price Details */}
                    <div className="col-md-4">
                        {/* Shipping Details */}
                        <div className="card p-3 mb-3 shadow-sm">
                            <h6 className="fw-bold">Shipping details</h6>
                            {/* <p className="mb-1 fw-bold">Aniket Kahandal</p> */}
                            <p className="text-muted small">
                                {location?.state?.OrderAddress}
                            </p>
                            {/* <p className="fw-bold mb-0">Phone number: 9623576236</p> */}
                        </div>

                        {/* Price Details (Using First Product) */}
                        {orders.length > 0 && (
                            <div className="card p-3 shadow-sm">
                                <h6 className="fw-bold">Price Details</h6>
                                <div className="d-flex justify-content-between">
                                    <p className=" fw-bold">Product price (₹)</p>
                                    <p className="fw-bold">{Math.round(totalRateAmount)}</p>
                                </div>
                                {location?.state?.CouponCodeAmount !== 0 ? (
                                    <div className="d-flex justify-content-between">
                                        <p className=" fw-bold">
                                            Coupon Amount (₹)
                                        </p>
                                        <p className=" fw-bold">
                                            {location?.state?.CouponCodeAmount}
                                        </p>
                                    </div>
                                ) : location?.state?.WalletAmount !== 0 ?
                                    <div className="d-flex justify-content-between">
                                        <p className=" fw-bold">
                                            Wallet Amount (₹)
                                        </p>
                                        <p className=" fw-bold" >
                                            {location?.state?.WalletAmount}
                                        </p>
                                    </div> : ''}
                                <div className="d-flex justify-content-between">
                                    <p className=" fw-bold">Discount Amount (₹) </p>
                                    <p className="fw-bold">{Math.round(totalDiscountAmount)}</p>
                                </div>
                                <hr></hr>
                                <div className="d-flex justify-content-between">
                                    <p className=" fw-bold">Total Amount (₹) </p>
                                    <p className="fw-bold">{Math.round(totalRateAmount) - Math.round(totalDiscountAmount) - (Number(location?.state?.CouponCodeAmount) === 0 ? Number(location?.state?.WalletAmount) : Number(location?.state?.CouponCodeAmount))}</p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p className="fw-bold">Tax ({location?.state?.TaxPercentage}%)</p>
                                    <p className=" fw-bold">
                                        <span>{location?.state?.TaxAmount}</span>
                                    </p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p className="fw-bold">Delivery Charge (₹)</p>
                                    <p className=" fw-bold">
                                        <span>{location?.state?.DeliveryCharges}</span>
                                    </p>
                                </div>
                                <hr></hr>
                                <div className="d-flex justify-content-between">
                                    <p className="fw-bold">Grand Total (₹)</p>
                                    <p className=" fw-bold">
                                        <span className=" fw-bold"> {Number(location?.state?.TRANSACTION_AMT)}</span>
                                    </p>
                                </div>

                            </div>
                        )}
                        {location?.state?.InvoicePDFURL !== null && (
                            <button
                                className="careox-btn mt-2"
                                onClick={() => handleDownloadInvoice(location?.state?.prasasdID)}
                            >
                                Download Invoice
                            </button>
                        )}

                    </div>
                </div>
            </div>
        </>
    )
}

export default PrasadOrderDetails
